export default __webpack_public_path__ + "static/media/0188cd7833abbc73cac24600144ab5401581611817555.3c8ff8fd.webp";